import React, { useEffect, useState } from 'react';
import Typography from '@mui/material/Typography';
import { alpha, Box, CircularProgress } from '@mui/material';
import { deleteDeposit, getSubmittedDeposits } from 'services/depositService';
import { Deposit, Item, Material } from 'types/api.types';
import DepositCard from 'components/common/DepositCard';
import { getItems, getMaterials } from 'services/lookupsService';
import { PointsIcon } from 'components/common/PointsIcon';
import { HourglassEmptyOutlined } from '@mui/icons-material';

const RecycleHistory: React.FC = () => {
  const [deposits, setDeposits] = useState<Deposit[]>([]);
  const [materials, setMaterials] = useState<Material[]>([]);
  const [items, setItems] = useState<Item[]>([]);
  const [isLoading, setLoading] = useState(false);

  const totalPendingPoints = deposits.map((item) => item.points || 0).reduce((a, b) => a + b, 0);

  useEffect(() => {
    setLoading(true);
    getMaterials().then((items) => items && setMaterials(items));
    getItems().then((items) => items && setItems(items));
    getSubmittedDeposits().then((deposits) => {
      setDeposits(deposits);
      setLoading(false);
    });
  }, []);

  const handleRemoveItem = async (id: number) => {
    await deleteDeposit(id);

    setDeposits((prev) => prev.filter((item) => item.id !== id));
  };
  if (isLoading)
    return (
      <Box
        sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '200px' }}
      >
        <CircularProgress />
      </Box>
    );

  return (
    <Box
      sx={{
        width: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <Typography
        variant="h5"
        gutterBottom
        sx={{ fontWeight: 600, display: 'flex', alignItems: 'center', gap: 1, p: 3 }}
      >
        Pending Submissions
      </Typography>
      <Box sx={{ width: '100%', maxWidth: 400, display: 'flex', flexDirection: 'column', gap: 2 }}>
        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2, mb: 1 }}>
          <Box
            sx={(theme) => ({
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              p: 2,
              border: `1px solid ${theme.palette.warning.main}`,
              background: alpha(theme.palette.warning.main, 0.1),
              borderRadius: '8px',
            })}
          >
            <Box sx={{ display: 'flex' }}>
              <HourglassEmptyOutlined
                sx={(theme) => ({ color: theme.palette.warning.main, mr: 1 })}
              />
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                Pending points
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <PointsIcon size={24} />
              <Typography variant="body1" sx={{ fontWeight: 600 }}>
                {totalPendingPoints}
              </Typography>
            </Box>
          </Box>
        </Box>
        {deposits.map((item) => (
          <DepositCard
            items={items}
            materials={materials}
            item={item}
            key={item.id}
            onDeleteClick={() => handleRemoveItem(item.id)}
          />
        ))}
      </Box>
    </Box>
  );
};

export default RecycleHistory;
